// extracted by mini-css-extract-plugin
export default {"wrapper":"SwipableDrawer_wrapper__Gt4NS","drawerButton":"SwipableDrawer_drawerButton__PZ54B","mobileOnly":"SwipableDrawer_mobileOnly__LRH6Y"};